module.exports = __webpack_public_path__ + "static/media/wall-rock.3377431f.png";